'use client';

import { c as _c } from "react/compiler-runtime";
import { forgotPassword } from '@/app/auth/forgot-password/actions';
import { useToast } from '@/components/Toast';
import { Alert, Button, Card, CardContent, CardHeader, CircularProgress, TextField } from '@mui/material';
import type { ReactElement } from 'react';
import { useActionState } from 'react';
type ForgotPasswordFormProps = {
  defaultEmail?: string;
};
export function ForgotPasswordForm(t0) {
  const $ = _c(25);
  const {
    defaultEmail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, formAction, pending] = useActionState(forgotPassword, t1);
  useToast();
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      maxWidth: 400,
      width: "100%"
    };
    t3 = <CardHeader title="Forgot your password?" subheader="We will send you an email with a link to set a new password" />;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      gap: 2
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== defaultEmail || $[5] !== state.formData) {
    t5 = state.formData?.get("email") ?? defaultEmail;
    $[4] = defaultEmail;
    $[5] = state.formData;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <TextField id="email" name="email" type="email" label="Email" placeholder="m@example.com" required={true} fullWidth={true} defaultValue={t5} />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== pending) {
    t7 = pending ? <CircularProgress size={20} color="inherit" /> : null;
    $[9] = pending;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = pending ? "Sending..." : "Send";
  let t9;
  if ($[11] !== pending || $[12] !== t7 || $[13] !== t8) {
    t9 = <Button type="submit" variant="contained" fullWidth={true} disabled={pending} startIcon={t7}>{t8}</Button>;
    $[11] = pending;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== state.formData || $[16] !== state.success) {
    t10 = state.success && <Alert severity="success" data-testid="forgot-password-success-message">Email sent to {state.formData?.get("email") as string ?? ""}. If you haven't received it, check your spam folder. If you still have trouble finding it, please ask an admin to invite you again.</Alert>;
    $[15] = state.formData;
    $[16] = state.success;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== state.error) {
    t11 = state.error && <Alert severity="error">Invalid email</Alert>;
    $[18] = state.error;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t6 || $[23] !== t9) {
    t12 = <Card sx={t2}>{t3}<CardContent component="form" action={formAction} sx={t4}>{t6}{t9}{t10}{t11}</CardContent></Card>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t6;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}